import {
  collection,
  doc,
  setDoc,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
} from "firebase/firestore";
import { db } from "./config";

// User profile operations
export const createUserProfile = async (userId, userData) => {
  try {
    await setDoc(doc(db, "users", userId), {
      ...userData,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getUserProfile = async (userId) => {
  try {
    const docRef = doc(db, "users", userId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { success: true, data: docSnap.data() };
    } else {
      return { success: false, error: "User not found" };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const updateUserProfile = async (userId, updates) => {
  try {
    const docRef = doc(db, "users", userId);
    await updateDoc(docRef, {
      ...updates,
      updatedAt: new Date(),
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Portfolio operations
export const createPortfolio = async (userId, portfolioData) => {
  try {
    const docRef = await addDoc(collection(db, "portfolios"), {
      userId,
      ...portfolioData,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
    return { success: true, portfolioId: docRef.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getUserPortfolios = async (userId) => {
  try {
    const q = query(
      collection(db, "portfolios"),
      where("userId", "==", userId),
      orderBy("createdAt", "desc")
    );
    const querySnapshot = await getDocs(q);

    const portfolios = [];
    querySnapshot.forEach((doc) => {
      portfolios.push({ id: doc.id, ...doc.data() });
    });

    return { success: true, data: portfolios };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const updatePortfolio = async (portfolioId, updates) => {
  try {
    const docRef = doc(db, "portfolios", portfolioId);
    await updateDoc(docRef, {
      ...updates,
      updatedAt: new Date(),
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const deletePortfolio = async (portfolioId) => {
  try {
    await deleteDoc(doc(db, "portfolios", portfolioId));
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Watchlist operations
export const addToWatchlist = async (userId, symbol, data) => {
  try {
    const docRef = await addDoc(collection(db, "watchlists"), {
      userId,
      symbol,
      ...data,
      createdAt: new Date(),
    });
    return { success: true, watchlistId: docRef.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getUserWatchlist = async (userId) => {
  try {
    const q = query(
      collection(db, "watchlists"),
      where("userId", "==", userId),
      orderBy("createdAt", "desc")
    );
    const querySnapshot = await getDocs(q);

    const watchlist = [];
    querySnapshot.forEach((doc) => {
      watchlist.push({ id: doc.id, ...doc.data() });
    });

    return { success: true, data: watchlist };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const removeFromWatchlist = async (watchlistId) => {
  try {
    await deleteDoc(doc(db, "watchlists", watchlistId));
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Transaction operations
export const addTransaction = async (userId, transactionData) => {
  try {
    const docRef = await addDoc(collection(db, "transactions"), {
      userId,
      ...transactionData,
      createdAt: new Date(),
    });
    return { success: true, transactionId: docRef.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getUserTransactions = async (userId) => {
  try {
    const q = query(
      collection(db, "transactions"),
      where("userId", "==", userId),
      orderBy("createdAt", "desc")
    );
    const querySnapshot = await getDocs(q);

    const transactions = [];
    querySnapshot.forEach((doc) => {
      transactions.push({ id: doc.id, ...doc.data() });
    });

    return { success: true, data: transactions };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Real-time listeners
export const subscribeToUserPortfolios = (userId, callback) => {
  const q = query(
    collection(db, "portfolios"),
    where("userId", "==", userId),
    orderBy("createdAt", "desc")
  );

  return onSnapshot(q, (querySnapshot) => {
    const portfolios = [];
    querySnapshot.forEach((doc) => {
      portfolios.push({ id: doc.id, ...doc.data() });
    });
    callback(portfolios);
  });
};

export const subscribeToUserWatchlist = (userId, callback) => {
  const q = query(
    collection(db, "watchlists"),
    where("userId", "==", userId),
    orderBy("createdAt", "desc")
  );

  return onSnapshot(q, (querySnapshot) => {
    const watchlist = [];
    querySnapshot.forEach((doc) => {
      watchlist.push({ id: doc.id, ...doc.data() });
    });
    callback(watchlist);
  });
};
